import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'course-authoring.import.page.title',
    defaultMessage: 'Studio Accessibility Policy| {siteName}',
  },
});

export default messages;
